import { Controller } from "@hotwired/stimulus"

// Per-ticket SLA timer. Reads fired_at and threshold (minutes), ticks
// every second, escalates colour at threshold (amber) and +5min beyond
// threshold (red).
export default class extends Controller {
  static values = { firedAt: String, threshold: Number }
  static targets = ["display"]

  connect() {
    if (!this.firedAtValue) return
    this.firedAt = new Date(this.firedAtValue).getTime()
    this.interval = setInterval(() => this.tick(), 1000)
    this.tick()
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    const elapsedMs = Date.now() - this.firedAt
    const elapsedMin = Math.floor(elapsedMs / 60000)
    const elapsedSec = Math.floor((elapsedMs % 60000) / 1000)
    const label = `${elapsedMin}m ${elapsedSec.toString().padStart(2, "0")}s`

    if (this.hasDisplayTarget) this.displayTarget.textContent = label

    const threshold = this.thresholdValue
    if (elapsedMin >= threshold + 5) {
      this.setEscalation("red")
    } else if (elapsedMin >= threshold) {
      this.setEscalation("amber")
    } else {
      this.setEscalation("normal")
    }
  }

  setEscalation(level) {
    if (!this.hasDisplayTarget) return
    const color = { normal: "#888", amber: "#fbbf24", red: "#ef4444" }[level]
    this.displayTarget.style.color = color
    this.displayTarget.style.fontWeight = level === "red" ? "700" : "400"
    if (level === "red") this.element.style.borderColor = "#ef4444"
  }
}
